import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAdBannerQuery } from "@/components/Banner/AdBanner";
import { getPassesUrlByAuthorId } from "@/components/edition/category/components/content/useProductItemHandlers";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { cn } from "@/lib/utils";
import { Button } from "@bookips/sds";
import { useRouter } from "next/router";
/**
 * 무료체험 끝 → 구매 유도 모듈 (Case 2)
 * - 광고 배너
 * - 즉시 무제한 이용하기 버튼
 */ const PurchaseTrialOverTab = (param)=>{
    let { product , freeTrialData , className , fullWidth , isInModal  } = param;
    const router = useRouter();
    const source = product.source;
    const subject = source === null || source === void 0 ? void 0 : source.subject;
    const { adBannerResponse , noAdItems  } = useAdBannerQuery({
        position: "productDetail",
        subject
    });
    // 즉시 무제한 이용하기 클릭 핸들러
    const handlePurchaseClick = ()=>{
        const passesUrl = getPassesUrlByAuthorId(product.author_id);
        mixpanelEvent("CTA Button Clicked", {
            "Button Type": "case2)무료체험 종료 후 구매 유도할 유저",
            "Button Name": "즉시 무제한 이용하기",
            "Button URL": passesUrl,
            Position: "상품상세페이지 구매모듈"
        });
        window.open(passesUrl, "_blank");
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: cn("flex flex-col gap-4", fullWidth || isInModal ? "w-full" : "w-[300px]", className),
        children: [
            !noAdItems && (adBannerResponse === null || adBannerResponse === void 0 ? void 0 : adBannerResponse.items[0]) && /*#__PURE__*/ _jsx("a", {
                href: adBannerResponse.items[0].link,
                target: "_blank",
                rel: "noopener noreferrer",
                className: "block w-full overflow-hidden rounded-md",
                children: /*#__PURE__*/ _jsx("img", {
                    src: adBannerResponse.items[0].imageUrl,
                    alt: "광고 배너",
                    className: "w-full h-auto"
                })
            }),
            /*#__PURE__*/ _jsx(Button, {
                variant: "fill",
                color: "primary",
                size: "lg",
                fullWidth: true,
                onClick: handlePurchaseClick,
                children: "즉시 무제한 이용하기"
            })
        ]
    });
};
export default PurchaseTrialOverTab;
